export default __webpack_public_path__ + "static/media/storyboardCloseup.9041d22b.jpeg";